module.exports = Em.Handlebars.compile("{{yield}}\n");